import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["size", "loading", "error", "message", "autoFocus", "onChange", "defaultValue", "value", "bgColor", "digitsOnly"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/PinInput/PinInput.js",
    _this = this;

import React, { useState, useEffect, useRef } from 'react';
import ReactOtpInput from 'react-otp-input';
import styled, { css } from 'styled-components';
import loadingAnimation from '@dls/assets/lottiefiles/loading';
import { useTheme, withTheme } from '../../core/ThemeProvider';
import { testIdProps, withOpacity, isNumber } from '../../helpers';
import { isString } from '../../core/utils/helpers';
import { Fade } from '../../core/animation';
import Animation from '../Animation';
import HintText from '../../core/components/Forms/HintText';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
export var ReactOtpInputClasses = {
  containerStyle: 'react-otp-input--containerStyle',
  inputStyle: 'react-otp-input--inputStyle',
  focusStyle: 'react-otp-input--focusStyle'
};

var PinInput = function PinInput(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 4 : _ref$size,
      loading = _ref.loading,
      error = _ref.error,
      message = _ref.message,
      autoFocus = _ref.autoFocus,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      bgColor = _ref.bgColor,
      digitsOnly = _ref.digitsOnly,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(value || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      pinValue = _useState2[0],
      setValue = _useState2[1];

  var inputRef = useRef(null);

  var onPinChange = function onPinChange(pinInputValue) {
    setValue(pinInputValue);
    onChange && onChange(pinInputValue);
  };

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  useEffect(function () {
    //when value changes, set new value to pinValue
    if (isString(value) || isNumber(value) || value === null) {
      setValue(value);
    }
  }, [value]);
  useEffect(function () {
    // when start loading, we need to out focus the PinInput
    // but 'react-otp-input' does not forward the ref to the nested inputs
    // so we need to focus and blur on a hidden input to out focus the PinInput
    if (loading) {
      var inputEl = inputRef ? inputRef.current : null;

      if (inputEl) {
        inputEl.focus();
        inputEl.blur();
      }
    }
  }, [loading]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, testIdProps(rest), {
    error: error,
    isLoading: loading,
    bgColor: bgColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(ReactOtpInput, {
    numInputs: size,
    value: pinValue,
    shouldAutoFocus: autoFocus,
    onChange: onPinChange,
    containerStyle: ReactOtpInputClasses.containerStyle,
    inputStyle: ReactOtpInputClasses.inputStyle,
    focusStyle: ReactOtpInputClasses.focusStyle,
    inputType: digitsOnly ? 'number' : 'text',
    renderInput: function renderInput(props) {
      return /*#__PURE__*/React.createElement("input", _extends({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80,
          columnNumber: 31
        }
      }));
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(_StyledFade, {
    visible: loading,
    $_css: size * 58 - 8,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(LoadingOverlay, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Animation, {
    "data-testid": "loading-animation",
    source: loadingAnimation,
    size: "30px",
    color: theme.cl_ter_l3,
    action: "play",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(HiddenInput, {
    ref: inputRef,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 7
    }
  }), error && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    error: true,
    "data-testid": "hintId",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 11
    }
  }, message)));
};

export default PinInput;
var Container = withTheme(styled.div.withConfig({
  displayName: "PinInput__Container",
  componentId: "sc-5nw43b-0"
})(function (_ref2) {
  var _coreTheme$otpPinInpu, _coreTheme$otpPinInpu2, _coreTheme$otpPinInpu3, _coreTheme$otpPinInpu4, _coreTheme$otpPinInpu5, _coreTheme$otpPinInpu6;

  var coreTheme = _ref2.coreTheme,
      error = _ref2.error,
      isLoading = _ref2.isLoading,
      bgColor = _ref2.bgColor;
  var inputStyle = {
    borderColor: 'transparent',
    color: coreTheme.cl_ter_base,
    backgroundColor: bgColor === 'haze' ? coreTheme.cl_ter_l6 : coreTheme.cl_white
  };
  var inputFocusStyle = {
    borderColor: coreTheme.cl_sec_d1
  };

  if (isLoading) {
    inputStyle.color = withOpacity(coreTheme.cl_ter_l3, 0.5);
    inputStyle.borderColor = 'transparent';
    inputFocusStyle.borderColor = 'transparent';
  }

  if (error) {
    inputStyle.borderColor = coreTheme.cl_errorRed;
    inputStyle.backgroundColor = coreTheme.cl_white;
    inputFocusStyle.borderColor = coreTheme.cl_errorRed;
  }

  return css(["display:flex;flex-direction:column;position:relative;.", "{> div:not(:last-of-type){margin-right:", "px;}}.", "{display:inline-block;outline:none;", " max-width:50px !important;width:100% !important;box-sizing:border-box;padding:0;border:1px solid transparent;border-color:", ";border-radius:", ";font-family:", ";", " color:", ";background-color:", ";margin-right:8px;&:focus{border-color:", ";background-color:", ";}&:not([value='']){background-color:", ";}&[value='']{border-color:", ";&:focus{border-color:", ";}}::-webkit-outer-spin-button,::-webkit-inner-spin-button{appearance:none;margin:0;}}"],
  /* sc-selector */
  ReactOtpInputClasses.containerStyle, coreTheme.space_2,
  /* sc-selector */
  ReactOtpInputClasses.inputStyle, Object.assign({}, responsiveStyles({
    height: (_coreTheme$otpPinInpu = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$otpPinInpu2 = coreTheme.otpPinInput) === null || _coreTheme$otpPinInpu2 === void 0 ? void 0 : _coreTheme$otpPinInpu2.height) !== null && _coreTheme$otpPinInpu !== void 0 ? _coreTheme$otpPinInpu : [73, 73, 73, 73, 73]
  }, coreTheme)), inputFocusStyle.borderColor, coreTheme.rad_xs, (_coreTheme$otpPinInpu3 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$otpPinInpu4 = coreTheme.otpPinInput) === null || _coreTheme$otpPinInpu4 === void 0 ? void 0 : _coreTheme$otpPinInpu4.fontFamily) !== null && _coreTheme$otpPinInpu3 !== void 0 ? _coreTheme$otpPinInpu3 : coreTheme.ff_sec_thin, Object.assign({}, responsiveStyles({
    fontSize: (_coreTheme$otpPinInpu5 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$otpPinInpu6 = coreTheme.otpPinInput) === null || _coreTheme$otpPinInpu6 === void 0 ? void 0 : _coreTheme$otpPinInpu6.fontSize) !== null && _coreTheme$otpPinInpu5 !== void 0 ? _coreTheme$otpPinInpu5 : [24, 24]
  }, coreTheme)), inputStyle.color, inputStyle.backgroundColor, inputFocusStyle.borderColor, coreTheme.cl_white, isLoading || error ? inputStyle.backgroundColor : coreTheme.cl_white, inputStyle.borderColor, inputFocusStyle.borderColor);
}));
var LoadingOverlay = styled.div.withConfig({
  displayName: "PinInput__LoadingOverlay",
  componentId: "sc-5nw43b-1"
})(["position:relative;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var HiddenInput = styled.input.withConfig({
  displayName: "PinInput__HiddenInput",
  componentId: "sc-5nw43b-2"
})(["position:absolute;opacity:0;z-index:-1;"]);

var _StyledFade = styled(Fade).withConfig({
  displayName: "PinInput___StyledFade",
  componentId: "sc-5nw43b-3"
})(function (p) {
  return {
    maxWidth: p.$_css,
    width: '100%',
    height: 73,
    position: 'absolute',
    top: 0,
    left: 0
  };
});